// Generated by GitHub Copilot
import Projects from "../components/Projects";

/**
 * Render the dedicated projects page.
 *
 * @param {{projects: Array<Record<string, any>>, config: Record<string, any>, loading?: boolean}} props Component props.
 * @returns {JSX.Element} Projects page section.
 */
function ProjectsPage({ projects, config, loading = false }) {
    return (
        <section className="mt-4 px-4 pb-6 md:px-8" id="projects-page">
            <Projects projects={projects} config={config} loading={loading} />
        </section>
    );
}

export default ProjectsPage;
